import * as i0 from '@angular/core';
import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

class DSIconComponent {
    icon;
    ariaLabel;
    enlarged = false;
    lineHeight = false;
    set size(value) {
        this.sizeClass = this.sizeClassType === 'icon' ? `icon-${value}x` : `rs-txt-s${value}`;
    }
    sizeClassType = 'icon';
    set marginSize(value) {
        this._marginSize = value;
        this.changeMarginSideClass();
    }
    set marginSide(value) {
        this._marginSide = value;
        this.changeMarginSideClass();
    }
    changeMarginSideClass() {
        this.marginSideClass =
            this._marginSide === 'left' ? `rs-margin-left${this._marginSize}` : `rs-margin-right${this._marginSize}`;
    }
    _marginSize = 1;
    _marginSide = 'right';
    sizeClass = '';
    marginSideClass = '';
    /** @nocollapse */ static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.4", ngImport: i0, type: DSIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    /** @nocollapse */ static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.0.4", type: DSIconComponent, isStandalone: true, selector: "lib-icon[icon], ds-icon[icon]", inputs: { icon: "icon", ariaLabel: "ariaLabel", enlarged: "enlarged", lineHeight: "lineHeight", size: "size", sizeClassType: "sizeClassType", marginSize: "marginSize", marginSide: "marginSide" }, ngImport: i0, template: "<i\n\t[class.icon-large]=\"enlarged\"\n\t[class.icon-lh]=\"lineHeight\"\n\t[ngClass]=\"[icon, sizeClass || '', marginSideClass || '']\"\n\t[attr.aria-hidden]=\"ariaLabel ? null : 'true'\"\n\t[attr.aria-label]=\"ariaLabel\"\n></i>\n", dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.4", ngImport: i0, type: DSIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-icon[icon], ds-icon[icon]', imports: [NgClass], template: "<i\n\t[class.icon-large]=\"enlarged\"\n\t[class.icon-lh]=\"lineHeight\"\n\t[ngClass]=\"[icon, sizeClass || '', marginSideClass || '']\"\n\t[attr.aria-hidden]=\"ariaLabel ? null : 'true'\"\n\t[attr.aria-label]=\"ariaLabel\"\n></i>\n" }]
        }], propDecorators: { icon: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], enlarged: [{
                type: Input
            }], lineHeight: [{
                type: Input
            }], size: [{
                type: Input
            }], sizeClassType: [{
                type: Input
            }], marginSize: [{
                type: Input
            }], marginSide: [{
                type: Input
            }] } });

var IconEnum;
(function (IconEnum) {
    IconEnum["Accessories"] = "icon-Accessories";
    IconEnum["Account"] = "icon-Account";
    IconEnum["Activeren"] = "icon-Activeren";
    IconEnum["Addition"] = "icon-Addition";
    IconEnum["Administration"] = "icon-Administration";
    IconEnum["Advantage"] = "icon-Advantage";
    IconEnum["AdvantagePig"] = "icon-Advantage-pig";
    IconEnum["AI"] = "icon-AI";
    IconEnum["Airplane"] = "icon-Airplane";
    IconEnum["Alarm"] = "icon-Alarm";
    IconEnum["Answers"] = "icon-Answers";
    IconEnum["Antenna"] = "icon-Antenna";
    IconEnum["Anywhere"] = "icon-Anywhere";
    IconEnum["Applications"] = "icon-Applications";
    IconEnum["Appointment"] = "icon-Appointment";
    IconEnum["Arrow"] = "icon-Arrow";
    IconEnum["ArrowCircle"] = "icon-Arrow-circle";
    IconEnum["ArrowDirection"] = "icon-Arrow-direction";
    IconEnum["ArrowDirectionHorizontal"] = "icon-Arrow-direction-horizontal";
    IconEnum["ArrowDown"] = "icon-Arrow-down";
    IconEnum["ArrowLeft"] = "icon-Arrow-left";
    IconEnum["ArrowNavigation"] = "icon-Arrow-navigation";
    IconEnum["ArrowOutline"] = "icon-Arrow-outline";
    IconEnum["ArrowOutlineDirection"] = "icon-Arrow-outline-direction";
    IconEnum["Arrowbutton"] = "icon-Arrowbutton";
    IconEnum["ArrowbuttonLeft"] = "icon-Arrowbutton-left";
    IconEnum["Articles"] = "icon-Articles";
    IconEnum["Baby"] = "icon-Baby";
    IconEnum["BackCamera"] = "icon-Back-camera";
    IconEnum["Battery"] = "icon-Battery";
    IconEnum["BelgiqueOk"] = "icon-Belgique-ok";
    IconEnum["BestSeller"] = "icon-Best-seller";
    IconEnum["BestSeller14"] = "icon-Best-seller-14";
    IconEnum["BestSeller2"] = "icon-Best-seller-2";
    IconEnum["Bill"] = "icon-Bill";
    IconEnum["BillMember"] = "icon-Bill-member";
    IconEnum["Birthday"] = "icon-Birthday";
    IconEnum["Blacklisted"] = "icon-Blacklisted";
    IconEnum["Blindness"] = "icon-Blindness";
    IconEnum["Bluetooth"] = "icon-Bluetooth";
    IconEnum["BrokenLinks"] = "icon-Broken-links";
    IconEnum["Bullet"] = "icon-Bullet";
    IconEnum["Caddy"] = "icon-Caddy";
    IconEnum["Calendar"] = "icon-Calendar";
    IconEnum["Calendar14"] = "icon-Calendar-14";
    IconEnum["Calendar7"] = "icon-Calendar-7";
    IconEnum["Calls"] = "icon-Calls";
    IconEnum["Callsfromabroad"] = "icon-Callsfromabroad";
    IconEnum["Callsfrombelgium"] = "icon-Callsfrombelgium";
    IconEnum["Callstransfert"] = "icon-Calltransfert";
    IconEnum["Camera"] = "icon-Camera";
    IconEnum["Car"] = "icon-Car";
    IconEnum["Card"] = "icon-Card";
    IconEnum["Care"] = "icon-Care";
    IconEnum["Circle"] = "icon-Circle";
    IconEnum["CircleRemove"] = "icon-Circle-Remove";
    IconEnum["Close"] = "icon-Close";
    IconEnum["Cloud"] = "icon-Cloud";
    IconEnum["CloudIct"] = "icon-Cloud-ICT";
    IconEnum["CloudIot"] = "icon-Cloud-IoT";
    IconEnum["CloudNetworks"] = "icon-Cloud-Networks";
    IconEnum["CloudSecurity"] = "icon-Cloud-Security";
    IconEnum["Collaboration"] = "icon-Collaboration";
    IconEnum["Collapse"] = "icon-Collapse";
    IconEnum["Community"] = "icon-Community";
    IconEnum["Community2"] = "icon-Community2";
    IconEnum["Compare"] = "icon-Compare";
    IconEnum["CongratulationsBox"] = "icon-Congratulations-box";
    IconEnum["ConnectedHouse"] = "icon-Connected-house";
    IconEnum["ConnectionError"] = "icon-Connection-error";
    IconEnum["ConnectionManager"] = "icon-Connection-manager";
    IconEnum["Connectivity"] = "icon-Connectivity";
    IconEnum["Contact"] = "icon-Contact";
    IconEnum["Contactlist"] = "icon-Contactlist";
    IconEnum["Contest"] = "icon-Contest";
    IconEnum["Continuity"] = "icon-Continuity";
    IconEnum["Cookie"] = "icon-Cookie";
    IconEnum["Crash"] = "icon-Crash";
    IconEnum["CustomerZone"] = "icon-Customer-Zone";
    IconEnum["Dance"] = "icon-Dance";
    IconEnum["Data"] = "icon-Data";
    IconEnum["Deafpeople"] = "icon-Deafpeople";
    IconEnum["Delivery"] = "icon-Delivery";
    IconEnum["Desktop"] = "icon-Desktop";
    IconEnum["Devices"] = "icon-Devices";
    IconEnum["Dial"] = "icon-Dial";
    IconEnum["DigitalMedia"] = "icon-Digital-media";
    IconEnum["Directassist"] = "icon-Directassist";
    IconEnum["Download"] = "icon-Download";
    IconEnum["Drag"] = "icon-Drag";
    IconEnum["ECarteFacebook"] = "icon-E-carte-Facebook";
    IconEnum["Easy"] = "icon-Easy";
    IconEnum["Edit"] = "icon-Edit";
    IconEnum["Energy"] = "icon-Energy";
    IconEnum["Entertainment"] = "icon-Entertainment";
    IconEnum["ErrorBox"] = "icon-Error-box";
    IconEnum["Eservices"] = "icon-Eservices";
    IconEnum["ExhibitionScreens"] = "icon-Exhibition-screens";
    IconEnum["Expand"] = "icon-Expand";
    IconEnum["Eyedeficiency"] = "icon-Eyedeficiency";
    IconEnum["Facebook"] = "icon-Facebook";
    IconEnum["Family"] = "icon-Family";
    IconEnum["Favourite"] = "icon-Favourite";
    IconEnum["FavouriteUnselected"] = "icon-Favourite-unselected";
    IconEnum["Feedback"] = "icon-Feedback";
    IconEnum["Fiber"] = "icon-Fiber";
    IconEnum["Filter"] = "icon-Filter";
    IconEnum["FixedConnection"] = "icon-Fixed-connection";
    IconEnum["FixedRinging"] = "icon-Fixed-ringing";
    IconEnum["Flexibility"] = "icon-Flexibility";
    IconEnum["FlexibleDelivery"] = "icon-Flexible-delivery";
    IconEnum["Football"] = "icon-Football";
    IconEnum["Football11"] = "icon-Football-11";
    IconEnum["Football11plus"] = "icon-Football-11plus";
    IconEnum["Forum"] = "icon-Forum";
    IconEnum["Forward"] = "icon-Forward";
    IconEnum["Freedelivery"] = "icon-Freedelivery";
    IconEnum["Freeservices"] = "icon-Freeservices";
    IconEnum["FrequentlyQuestions"] = "icon-Frequently-questions";
    IconEnum["FrontCamera"] = "icon-Front-camera";
    IconEnum["GTablet"] = "icon-G-Tablet";
    IconEnum["Gallery"] = "icon-Gallery";
    IconEnum["Games"] = "icon-Games";
    IconEnum["Gift"] = "icon-Gift";
    IconEnum["Government"] = "icon-Government";
    IconEnum["Guitar"] = "icon-Guitar";
    IconEnum["Handicap"] = "icon-Handicap";
    IconEnum["Help"] = "icon-Help";
    IconEnum["Home"] = "icon-Home";
    IconEnum["HomeAddedValue"] = "icon-Home-added-value";
    IconEnum["Hub"] = "icon-Hub";
    IconEnum["ICT"] = "icon-ICT";
    IconEnum["IconMoodHappy"] = "icon-Icon-Mood-happy";
    IconEnum["IconMoodNeutral"] = "icon-Icon-Mood-neutral";
    IconEnum["IconMoodUnhappy"] = "icon-Icon-Mood-unhappy";
    IconEnum["IctNetworking"] = "icon-Ict-networking";
    IconEnum["Idea"] = "icon-Idea";
    IconEnum["Incomingcalls"] = "icon-Incomingcalls";
    IconEnum["Infinity"] = "icon-Infinity";
    IconEnum["Information"] = "icon-Information";
    IconEnum["InformationBox"] = "icon-Information-box";
    IconEnum["Infrastructure"] = "icon-Infrastructure";
    IconEnum["Innovation"] = "icon-Innovation";
    IconEnum["Inscription"] = "icon-Inscription";
    IconEnum["Instagram"] = "icon-Instagram";
    IconEnum["International"] = "icon-International";
    IconEnum["Internet"] = "icon-Internet";
    IconEnum["Internetlaptop"] = "icon-Internetlaptop";
    IconEnum["Internetmobile"] = "icon-Internetmobile";
    IconEnum["Internettablet"] = "icon-Internettablet";
    IconEnum["InvoiceInsightAdvanced"] = "icon-Invoice-insight-advanced";
    IconEnum["Layer243"] = "icon-Layer243";
    IconEnum["Linkedin"] = "icon-Linkedin";
    IconEnum["Links"] = "icon-Links";
    IconEnum["LocalData"] = "icon-Local-data";
    IconEnum["Location"] = "icon-Location";
    IconEnum["Login1"] = "icon-Login1";
    IconEnum["Login2"] = "icon-Login2";
    IconEnum["LoginOpen"] = "icon-LoginOpen";
    IconEnum["Logout"] = "icon-Logout";
    IconEnum["LowStock"] = "icon-Low-stock";
    IconEnum["Magnify"] = "icon-Magnify";
    IconEnum["Manual"] = "icon-Manual";
    IconEnum["Markets"] = "icon-Markets";
    IconEnum["Meeting"] = "icon-Meeting";
    IconEnum["Mentaldeficiency"] = "icon-Mentaldeficiency";
    IconEnum["Menu"] = "icon-Menu";
    IconEnum["Menuburger"] = "icon-Menuburger";
    IconEnum["Messaging"] = "icon-Messaging";
    IconEnum["Messenger"] = "icon-Messenger";
    IconEnum["Micro"] = "icon-Micro";
    IconEnum["MicroSIMCard"] = "icon-MicroSIM-card";
    IconEnum["MicrosoftOffice"] = "icon-Microsoft-Office";
    IconEnum["MinusFill"] = "icon-Minus-fill";
    IconEnum["Minutes120"] = "icon-Minutes120";
    IconEnum["Minutes15"] = "icon-Minutes15";
    IconEnum["Minutes1600"] = "icon-Minutes1600";
    IconEnum["Minutes240"] = "icon-Minutes240";
    IconEnum["Minutes30"] = "icon-Minutes30";
    IconEnum["Minutes400"] = "icon-Minutes400";
    IconEnum["Minutes60"] = "icon-Minutes60";
    IconEnum["Minutes800"] = "icon-Minutes800";
    IconEnum["Mobile"] = "icon-Mobile";
    IconEnum["MobileCoverage"] = "icon-Mobile-Coverage";
    IconEnum["MobilityInsurance"] = "icon-Mobility-insurance";
    IconEnum["Monitoring"] = "icon-Monitoring";
    IconEnum["MoodJoy"] = "icon-Mood-joy";
    IconEnum["MoodVeryBad"] = "icon-Mood-very-bad";
    IconEnum["MoveSticker"] = "icon-Move-Sticker";
    IconEnum["MoveBox"] = "icon-Move-box";
    IconEnum["Moving"] = "icon-Moving";
    IconEnum["Music"] = "icon-Music";
    IconEnum["Myentertainment"] = "icon-Myentertainment";
    IconEnum["Network"] = "icon-Network";
    IconEnum["Newsletter"] = "icon-Newsletter";
    IconEnum["Next"] = "icon-Next";
    IconEnum["NoPlaying"] = "icon-No-playing";
    IconEnum["NoStock"] = "icon-No-stock";
    IconEnum["NortonSecurity"] = "icon-Norton-security";
    IconEnum["NotAvailable"] = "icon-Not-Available";
    IconEnum["Number1"] = "icon-Number-1";
    IconEnum["Number10"] = "icon-Number-10";
    IconEnum["Number2"] = "icon-Number-2";
    IconEnum["Number3"] = "icon-Number-3";
    IconEnum["Number4"] = "icon-Number-4";
    IconEnum["Number5"] = "icon-Number-5";
    IconEnum["Number6"] = "icon-Number-6";
    IconEnum["Number7"] = "icon-Number-7";
    IconEnum["Number8"] = "icon-Number-8";
    IconEnum["Number9"] = "icon-Number-9";
    IconEnum["OS"] = "icon-OS";
    IconEnum["OnApp"] = "icon-On-app";
    IconEnum["OnWeb"] = "icon-On-web";
    IconEnum["OneClick"] = "icon-OneClick";
    IconEnum["OnlineExcluEn"] = "icon-Online-exclu-en";
    IconEnum["OnlineExcluFr"] = "icon-Online-exclu-fr";
    IconEnum["OnlineExcluNl"] = "icon-Online-exclu-nl";
    IconEnum["OnlinePromoEn"] = "icon-Online-promo-en";
    IconEnum["OnlinePromoFr"] = "icon-Online-promo-fr";
    IconEnum["OnlinePromoNl"] = "icon-Online-promo-nl";
    IconEnum["Options"] = "icon-Options";
    IconEnum["Outcomingcalls"] = "icon-Outcomingcalls";
    IconEnum["Overview"] = "icon-Overview";
    IconEnum["Packs"] = "icon-Packs";
    IconEnum["Paperclip"] = "icon-Paperclip";
    IconEnum["Pedestrian"] = "icon-Pedestrian";
    IconEnum["Photo"] = "icon-Photo";
    IconEnum["Picture"] = "icon-Picture";
    IconEnum["Pin"] = "icon-Pin";
    IconEnum["PlaceMap"] = "icon-Place-map";
    IconEnum["Play"] = "icon-Play";
    IconEnum["Plus"] = "icon-Plus";
    IconEnum["PlusFill"] = "icon-Plus-fill";
    IconEnum["Points"] = "icon-Points";
    IconEnum["Positioning"] = "icon-Positioning";
    IconEnum["Posts"] = "icon-Posts";
    IconEnum["Presencehome"] = "icon-Presencehome";
    IconEnum["Previous"] = "icon-Previous";
    IconEnum["Prime"] = "icon-Prime";
    IconEnum["Print"] = "icon-Print";
    IconEnum["Processor"] = "icon-Processor";
    IconEnum["Products"] = "icon-Products";
    IconEnum["Promo"] = "icon-Promo";
    IconEnum["ProximusTvApp"] = "icon-Proximus-TV-app";
    IconEnum["Pxs"] = "icon-Pxs";
    IconEnum["Quote"] = "icon-Quote";
    IconEnum["RaccordingFlat"] = "icon-Raccording-flat";
    IconEnum["ReadyToUse"] = "icon-Ready-to-use";
    IconEnum["Recycling"] = "icon-Recycling";
    IconEnum["Reducer"] = "icon-Reducer";
    IconEnum["Refresh"] = "icon-Refresh";
    IconEnum["Relaunch"] = "icon-Relaunch";
    IconEnum["Reload"] = "icon-Reload";
    IconEnum["Remote"] = "icon-Remote";
    IconEnum["Remove"] = "icon-Remove";
    IconEnum["RemoveFilter"] = "icon-Remove-filter";
    IconEnum["Restart"] = "icon-Restart";
    IconEnum["Roaming"] = "icon-Roaming";
    IconEnum["RoamingBelgium"] = "icon-Roaming-Belgium";
    IconEnum["Search"] = "icon-Search";
    IconEnum["SecurePayment"] = "icon-Secure-payment";
    IconEnum["Seealso"] = "icon-Seealso";
    IconEnum["Server"] = "icon-Server";
    IconEnum["Settings"] = "icon-Settings";
    IconEnum["Shopmag"] = "icon-Shopmag";
    IconEnum["SmarphoneConfiguration"] = "icon-Smarphone-configuration";
    IconEnum["SmartRinging"] = "icon-Smart-ringing";
    IconEnum["Smartphone"] = "icon-Smartphone";
    IconEnum["Smartphone1"] = "icon-Smartphone-1";
    IconEnum["Smartphone2"] = "icon-Smartphone-2";
    IconEnum["Smartphone3"] = "icon-Smartphone-3";
    IconEnum["Smartphone4"] = "icon-Smartphone-4";
    IconEnum["Smartphone5"] = "icon-Smartphone-5";
    IconEnum["Smartphone6"] = "icon-Smartphone-6";
    IconEnum["Smartphone4G"] = "icon-Smartphone-4G";
    IconEnum["Smiley"] = "icon-Smiley";
    IconEnum["Sms"] = "icon-Sms";
    IconEnum["Sondage"] = "icon-Sondage";
    IconEnum["Sort0_9"] = "icon-Sort-0-9";
    IconEnum["Sort9_0"] = "icon-Sort-9-0";
    IconEnum["SortA_Z"] = "icon-Sort-a-z";
    IconEnum["SortZ_A"] = "icon-Sort-z-a";
    IconEnum["SoundOff"] = "icon-Sound-off";
    IconEnum["SoundOn"] = "icon-Sound-on";
    IconEnum["Speed"] = "icon-Speed";
    IconEnum["SpeedtestDownload"] = "icon-Speedtest-download";
    IconEnum["SpeedtestUpload"] = "icon-Speedtest-upload";
    IconEnum["StatusNok"] = "icon-Status-nok";
    IconEnum["StatusOk"] = "icon-Status-ok";
    IconEnum["StatusOngoing"] = "icon-Status-ongoing";
    IconEnum["StatusWarning"] = "icon-Status-warning";
    IconEnum["StayInformed"] = "icon-Stay-informed";
    IconEnum["Stayinformed"] = "icon-Stayinformed";
    IconEnum["Stock"] = "icon-Stock";
    IconEnum["Stopwatch"] = "icon-Stopwatch";
    IconEnum["Subscription"] = "icon-Subscription";
    IconEnum["Surfgsm"] = "icon-Surfgsm";
    IconEnum["Sustainability"] = "icon-Sustainability";
    IconEnum["SwitchonSwitchoff"] = "icon-Switchon-switchoff";
    IconEnum["TVReplay"] = "icon-TVReplay";
    IconEnum["Tablet"] = "icon-Tablet";
    IconEnum["Tailor"] = "icon-Tailor";
    IconEnum["TargetBlank"] = "icon-Target-Blank";
    IconEnum["Tarifs"] = "icon-Tarifs";
    IconEnum["TechnicalCast"] = "icon-Technical-cast";
    IconEnum["Telephony"] = "icon-Telephony";
    IconEnum["Television"] = "icon-Television";
    IconEnum["Temp"] = "icon-Temp";
    IconEnum["Tips1"] = "icon-Tips1";
    IconEnum["Tips2"] = "icon-Tips2";
    IconEnum["Tools"] = "icon-Tools";
    IconEnum["Top"] = "icon-Top";
    IconEnum["Touchscreens"] = "icon-Touchscreens";
    IconEnum["Tractor"] = "icon-Tractor";
    IconEnum["Train"] = "icon-Train";
    IconEnum["Transfer"] = "icon-Transfer";
    IconEnum["TransferPeople"] = "icon-Transfer-people";
    IconEnum["Trash"] = "icon-Trash";
    IconEnum["Triangle"] = "icon-Triangle";
    IconEnum["Tv10"] = "icon-TV-10";
    IconEnum["TV12"] = "icon-TV-12";
    IconEnum["Tv14"] = "icon-TV-14";
    IconEnum["Tv16"] = "icon-TV-16";
    IconEnum["Tv18"] = "icon-TV-18";
    IconEnum["Twitter"] = "icon-Twitter";
    IconEnum["UnderConstruct"] = "icon-Under-construct";
    IconEnum["UpgradeAccount"] = "icon-Upgrade-account";
    IconEnum["Upload"] = "icon-Upload";
    IconEnum["Usage"] = "icon-Usage";
    IconEnum["Usage2"] = "icon-Usage-2";
    IconEnum["ValidationBox"] = "icon-Validation-box";
    IconEnum["Video"] = "icon-Video";
    IconEnum["VideoZap"] = "icon-Video-zap";
    IconEnum["Videoscope"] = "icon-Videoscope";
    IconEnum["View360"] = "icon-View360";
    IconEnum["Waiting"] = "icon-Waiting";
    IconEnum["WarningBox"] = "icon-Warning-box";
    IconEnum["Watch"] = "icon-Watch";
    IconEnum["Watch2"] = "icon-Watch2";
    IconEnum["WhatsApp"] = "icon-WhatsApp";
    IconEnum["WirelessHub"] = "icon-Wireless-hub";
    IconEnum["Youtube"] = "icon-Youtube";
    IconEnum["CircularEconomy"] = "icon-circular-economy";
    IconEnum["Eco"] = "icon-eco";
    IconEnum["HappyWeeks"] = "icon-happy-weeks";
    IconEnum["IconVOD"] = "icon-icon-VOD";
    IconEnum["Mms"] = "icon-mms";
    IconEnum["NewEn"] = "icon-new-en";
    IconEnum["NewFr"] = "icon-new-fr";
    IconEnum["NewNl"] = "icon-new-nl";
    IconEnum["Prepaid"] = "icon-prepaid";
    IconEnum["promo"] = "icon-promo";
    IconEnum["RepairDevice"] = "icon-repair-device";
    IconEnum["SalesEn"] = "icon-sales-en";
    IconEnum["SalesFr"] = "icon-sales-fr";
    IconEnum["SalesNl"] = "icon-sales-nl";
    IconEnum["Simlocked"] = "icon-simlocked";
})(IconEnum || (IconEnum = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { DSIconComponent, IconEnum };
